import React, { useState } from 'react'
import { create, muiDialogV5, useModal } from '@ebay/nice-modal-react'
import { /* Button, */ InputAdornment, OutlinedInput, Typography } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
// import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward'
import { useDebounce } from 'ahooks'
import Dialog from '../common/Dialog'
import { FlexCol } from '../common/Columns'
import RecommendedTokens from './RecommendedTokens'
import TokenList from './TokenList'

interface SelectTokenDialogProps {
  mode: 'btc' | 'evm'
}

const SelectTokenDialog = ({ mode }: SelectTokenDialogProps) => {
  const modal = useModal()

  const [searchInput, setSearchInput] = useState('')
  const debouncedSearchInput = useDebounce(searchInput, { wait: 500 })

  return (
    <Dialog {...muiDialogV5(modal)}>
      <FlexCol sx={{ rowGap: { xs: 24, md: 40 }, minWidth: { xs: 'auto', md: 400 } }}>
        <Typography fontSize={{ xs: 24, md: 32 }}>Select a token</Typography>

        <FlexCol sx={{ rowGap: { xs: 12, md: 20 } }}>
          <OutlinedInput
            size="small"
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon sx={{ opacity: 0.5 }} />
              </InputAdornment>
            }
            placeholder="Search name or paste address"
            onChange={(e) => {
              setSearchInput(e.target.value)
            }}
          />

          <RecommendedTokens
            mode={mode}
            onSelect={() => {
              modal.hide()
            }}
          />
        </FlexCol>

        <TokenList
          mode={mode}
          onSelect={() => {
            modal.hide()
          }}
          searchInput={debouncedSearchInput}
        />

        {/* <Button size="small" sx={{ mx: 'auto' }}>
          Cross-chain application
          <ArrowOutwardIcon sx={{ width: 20, height: 20 }} />
        </Button> */}
      </FlexCol>
    </Dialog>
  )
}

export default create(SelectTokenDialog)
